import React from 'react';
import { SubmitButton } from '../../../../shared/components';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { AuthFormActions as Actions } from '../../../shared/form-layout/AuthFormActions';
import { useChangePasswordFormContext } from './hooks/useChangePasswordFormContext';
import { useChangePasswordHasRequiredFields } from './hooks/useChangePasswordHasRequiredFields';

export const ChangePasswordSubmit = () => {
	const { t } = useTranslation();
	const { formState } = useChangePasswordFormContext();

	const hasRequiredFields = useChangePasswordHasRequiredFields();
	const disabled = !hasRequiredFields || formState.isSubmitting;

	return (
		<Actions>
			<SubmitButton disabled={disabled}>
				{t('user_reset_password_submit_button')}
			</SubmitButton>
		</Actions>
	);
};
